<template>
  <div class="gm-page pa-4">
    <PageTop :menus="['主监控', '电站拓扑', '储能系统']" />

    <div class="summary-content flex-grow-1 d-flex flex-column overflow-hidden mt-4">
      <!-- 中间：设备概况卡片 -->
      <v-card class="rounded-xl card-bg card-bd flex-shrink-0" variant="elevated" elevation="0" :loading="ov_loading">
        <template #title>设备概况</template>
        <div class="overview-grid">
          <div class="overview-card">
            <img src="./imgs/ess1.png" width="50" alt="" class="grid-item">
            <div class="grid-item">
              <div class="d-flex align-center">
                <DataCard title="" :value="fmtp(overview.station?.sumPower || 0, 3).value"
                  :unit="fmtp(overview.station?.sumPower || 0).unit" title-position="bottom" :value-style="valueStyle">
                </DataCard>
                <span>/</span>
                <DataCard title="" :value="fmte(overview.station?.sumCapacity || 0, 3).value"
                  :unit="fmte(overview.station?.sumCapacity || 0).unit" title-position="bottom"
                  :value-style="valueStyle">
                </DataCard>
              </div>
              <div class="px-2" style="font-size: 14px;color: #6e7185;">储能总装机容量</div>
            </div>
            <v-divider vertical class="grid-item" color="#DAECFF" opacity="1"></v-divider>
            <div class="grid-item">
              <DataCard title="能量块(在线/总)"
                :value="(overview.station?.online || 0) + '/' + (overview.station?.total || 0)" unit=""
                title-position="bottom" :value-style="valueStyle">
              </DataCard>
            </div>
            <v-divider vertical class="grid-item" color="#DAECFF" opacity="1"></v-divider>
            <div class="grid-item">
              <DataCard title="储能设备在线率" :value="overview.station?.online" unit="%" title-position="bottom"
                :value-style="valueStyle">
                <template #value>
                  <span style="font-size: 20px; font-weight: 600;">{{ getPercentage(overview.station?.online,
                    overview.station?.total) }}</span> %
                  <v-progress-linear :model-value="getPercentage(overview.station?.online, overview.station?.total)"
                    color="#2DAE55" rounded></v-progress-linear>
                </template>
              </DataCard>
            </div>
          </div>
          <div class="overview-card">
            <img src="./imgs/pv1.png" width="50" alt="" class="grid-item">
            <div class="grid-item">
              <div class="d-flex align-center">
                <DataCard title="" :value="fmtp(overview.photovoltaic?.sumPower || 0, 3).value"
                  :unit="fmtp(overview.photovoltaic?.sumPower || 0).unit + 'p'" title-position="bottom"
                  :value-style="valueStyle">
                </DataCard>
              </div>
              <div class="px-2" style="font-size: 14px;color: #6e7185;">光伏总装机容量</div>
            </div>
            <v-divider vertical class="grid-item" color="#DAECFF" opacity="1"></v-divider>
            <div class="grid-item">
              <DataCard title="光伏设备(在线/总)"
                :value="(overview.photovoltaic?.online || 0) + '/' + (overview.photovoltaic?.total || 0)" unit=""
                title-position="bottom" :value-style="valueStyle">
              </DataCard>
            </div>
            <v-divider vertical class="grid-item" color="#DAECFF" opacity="1"></v-divider>
            <div class="grid-item">
              <DataCard title="光伏设备在线率" :value="overview.photovoltaic?.online" unit="%" title-position="bottom"
                :value-style="valueStyle">
                <template #value>
                  <span style="font-size: 20px; font-weight: 600;">{{ getPercentage(overview.photovoltaic?.online,
                    overview.photovoltaic?.total) }}</span> %
                  <v-progress-linear
                    :model-value="getPercentage(overview.photovoltaic?.online, overview.photovoltaic?.total)"
                    color="#2DAE55" rounded></v-progress-linear>
                </template>
              </DataCard>
            </div>
          </div>
        </div>
      </v-card>

      <!-- 底部：电站总览表格 -->
      <v-card
        class="station-overview-card rounded-xl card-bg card-bd flex-grow-1 d-flex flex-column overflow-hidden mt-4"
        variant="elevated" elevation="0" :loading="ls_loading">
        <template #title>
          <div class="d-flex justify-space-between align-center w-100">
            <div>电站总览 <v-btn variant="text" size="small" icon="mdi-refresh" @click="() => updateStationList()"></v-btn>
            </div>
            <div class="station-search">
              <v-text-field v-model="searchKeyword" placeholder="输入电站名称或id搜索" rounded="pill" variant="outlined"
                density="compact" hide-details clearable class="search-input" style="width: 250px;"
                @keyup="handleSearch" @click:clear="handleSearch">
                <template #append-inner>
                  <v-icon icon="mdi-magnify" size="small" class="search-icon" @click="handleSearch" />
                </template>
              </v-text-field>
            </div>
          </div>
        </template>
        <div class="table-wrapper d-flex flex-column flex-grow-1 overflow-hidden  px-4" style="padding-bottom: 18px;">
          <v-table fixed-header density="default" class="bg-transparent flex-grow-1 overflow-auto gm-table"
            :key="tableKey">
            <thead>
              <tr>
                <th class="text-left font-weight-regular header-cell">电站名称</th>
                <th class="text-left font-weight-regular header-cell">主要设备型号</th>
                <th class="text-left font-weight-regular header-cell">通信状态</th>
                <th class="text-left font-weight-regular header-cell">告警状态</th>
                <th class="text-left font-weight-regular header-cell">运行状态</th>
                <th class="text-left font-weight-regular header-cell">SOC(%)</th>
                <th class="text-left font-weight-regular header-cell">剩余电量(kWh)</th>
                <th class="text-left font-weight-regular header-cell">实时功率(kW)</th>
                <th class="text-left font-weight-regular header-cell">电网电压(V)</th>
                <th class="text-left font-weight-regular header-cell">柜体平均温度/最高温度</th>
                <th class="text-left font-weight-regular header-cell">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in stationList" :key="row.id || index">
                <td class="body-cell ">
                  <div>
                    <div class="station-name" @click="handleClick(row)">{{ row.name || '-' }}</div>
                    <div class="station-capacity">{{ (row.maxPower / 1000).toFixed(2) || '-' }}MW / {{
                      (row.capacity / 1000).toFixed(2) || '-' }}MWh</div>
                  </div>

                </td>
                <td class="body-cell">
                  <div>{{ getDeviceModel(row) }}</div>
                  <div style="font-size: 12px;color: #6e7185;">eBlock数量: {{ row.eBlockNum }}</div>
                </td>
                <td class="body-cell">
                  <v-chip variant="outlined" size="small" class="comm-status"
                    :class="row.commStatus > 0 ? 'online' : 'offline'"
                    :color="row.commStatus > 0 ? '#33BE36' : '#6B6C6D'"
                    :prepend-icon="row.commStatus > 0 ? Wifi : WifiOff">
                    {{ getCommStatus(row.commStatus) || '-' }}
                  </v-chip>
                </td>
                <td class="body-cell">
                  <TriangleAlert color="#FF6A46" v-if="row.alarmStatus > 0" v-tooltip="row.alarmStatus + ' 条告警'"
                    @click="handleAlarm(row)" style="cursor: pointer;" />
                  <span v-else>-</span>
                </td>
                <td class="body-cell">

                  <div class="d-flex align-center ga-2">
                    <div class="run-status-dot" :class="runningStatusMap.getClass(row.runningStatus)"></div>
                    <span>{{ runningStatusMap.getText(row.runningStatus) || '-' }}</span>
                  </div>

                </td>
                <td class="body-cell">
                  <div class="d-flex align-center ga-4">
                    <Battery :soc="row.soc" />
                  </div>
                </td>
                <td class="body-cell">
                  <div class="d-flex align-center ga-4">
                    <span>{{ row.dumpEnergy ?? '-' }}</span>
                  </div>
                </td>

                <td class="body-cell">
                  <div class="d-flex align-center ga-2">
                    <div class="simple-chart" :id="`simple-chart-${row.stationId}`"></div>
                    <div class="station-power"> {{ row.power ?? '-' }}</div>
                  </div>
                </td>
                <td class="body-cell">{{ row.gridVoltage ?? '-' }}</td>
                <td class="body-cell">{{ row.avgTemperature != null && row.maxTemperature != null ?
                  `${row.avgTemperature}℃ /
                  ${row.maxTemperature}℃` :
                  '-' }}</td>
                <td class="body-cell">
                  <v-btn variant="text" color="#426CF9" rounded="xl" size="small" @click="handleOperate(row)">
                    详情
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-table>
          <div v-if="stationList.length === 0" class="empty-tip text-center py-8 text-medium-emphasis">
            {{ searchKeyword ? '未找到匹配的电站' : '暂无电站数据' }}
          </div>

          <TablePagination :total="total" :pageSize="pageSize" v-model="page" @change="() => updateStationList()" />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, nextTick } from 'vue';
import PageTop from '@/components/PageTop/index.vue';
import DataCard from '@/views/home/components/DataCard/index.vue';
import { Wifi, WifiOff, TriangleAlert } from 'lucide-vue-next';
import Battery from '@/components/Battery/index.vue';
import { initChart } from '@/utils';
import Opt from './opt';
import { useRouter, useRoute } from 'vue-router'
import { getOverview, getStationMonitorList } from '@/api/station-monitor'
import { createStatusMap } from '@/utils';
import { debounce } from 'lodash-es';
import { fmte, fmtp } from '@/utils/fortmatter'
import TablePagination from '@/components/TablePagination/index.vue'

const router = useRouter();

const tableKey = ref(0);
const searchKeyword = ref('');

const valueStyle = {
  'font-size': '20px',
  'font-weight': '600',
}

// 设备概况数据
const overview = ref({
  station: {},
  photovoltaic: {}
});

// 电站总览列表
const stationList = ref([]);

const page = ref(1)
const total = ref(0)
const pageSize = ref(10)

async function update() {
  try {
    await Promise.all([
      updateOverview(),
      updateStationList(),
    ])
    await nextTick()
    initOrUpdateSimpleChart()
  } catch (error) {
    console.warn('更新失败', error);
  }
}


const ov_loading = ref(false)
async function updateOverview() {
  ov_loading.value = true
  try {
    const overviewRes = await getOverview()
    overview.value = overviewRes?.data || { station: {}, photovoltaic: {} }
  } catch (error) {
    console.warn('更新失败', error);
  } finally {
    ov_loading.value = false
  }
}

const ls_loading = ref(false)
async function updateStationList(id, name) {
  ls_loading.value = true
  try {
    const stationListRes = await getStationMonitorList({
      pageSize: pageSize.value,
      pageNum: page.value,
      name: name,
      stationId: id
    })
    stationList.value = (stationListRes.rows || []).filter(r => r != null)
    total.value = stationListRes.total

    await nextTick()
    initOrUpdateSimpleChart()
  } catch (error) {
    console.warn('更新失败', error);
  } finally {
    ls_loading.value = false
  }
}

// 防抖更新电站列表，避免频繁请求
const debounceUpdateStationList = debounce(updateStationList, 500, { trailing: true })

function handleSearch() {
  page.value = 1

  if (isNumber(searchKeyword.value)) {
    debounceUpdateStationList(searchKeyword.value)
  } else {
    debounceUpdateStationList(null, searchKeyword.value)
  }
}

function isNumber(str) {
  return /^\d+$/.test(str);
}

// 转义 HTML，防止 XSS
function escapeHtml(str) {
  if (str == null) return '';
  const s = String(str);
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function handleOperate(row) {
  // 跳转电站详情或打开弹窗
  console.log('操作', row);
  router.push({
    path: '/station-monitor/detail',
    query: {
      stationId: row.stationId,
    }
  })
}

function getCommStatus(status) {
  return status > 0 ? '在线' : '离线';
}

// 1:停机 2:待机 3:充电 4:放电
const runningStatusMap = createStatusMap({
  1: { text: '停机', class: 'stop' },
  2: { text: '待机', class: 'standby' },
  3: { text: '充电', class: 'charge' },
  4: { text: '放电', class: 'discharge' },
})

onMounted(async () => {
  await update()
});

let charts = {}
const initOrUpdateSimpleChart = () => {
  // 销毁所有图表
  Object.keys(charts).forEach(key => {
    try { charts[key].dispose() } catch (e) { /* ignore */ }
  })
  charts = {}

  // 初始化简单图表
  stationList.value.forEach((row) => {
    if (!row?.stationId) return
    const el = document.getElementById(`simple-chart-${row.stationId}`)
    if (!el) return
    charts[row.stationId] = initChart(el, null, Opt(row.powerChart))
  })
}

function getPercentage(a, b) {
  if (!b) return '0';
  return ((a / b) * 100).toFixed(2);
}

function handleClick(row) {
  console.log('点击', row);
  handleOperate(row)
}

function getDeviceModel(row) {
  const model = (row?.eBlockModel || '').split(',')[0] || '-'
  if (model == 'cluster418-2g') {
    return 'eBlock-Galaxy-2g'
  }
  return model
}

function handleAlarm(row) {
  console.log('告警', row);
  router.push({
    path: '/it-operations/detail',
    query: {
      tab: '告警信息',
      stationId: row.stationId,
    }
  })
}
</script>

<style scoped lang="scss">
.summary-page {
  min-height: 0;
}

.summary-content {
  min-height: 0;
}

.card-bg {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.42) 104.73%);
}

.card-bd {
  border: 1px solid #fff;
}

.grid-item {
  margin: 0 auto;
}

.overview-card {
  background: linear-gradient(123.04deg, #E7F3FF 7.74%, rgba(247, 251, 255, 0.877) 84.74%);
  padding: 16px;
  align-items: center;
  display: grid;
  grid-template-columns: 50px minmax(130px, 1.25fr) 1px minmax(92px, 0.8fr) 1px minmax(120px, 1.1fr);
  border-radius: 15px;


  gap: 10px;

  :deep(.data-card) {
    padding-bottom: 0;
    padding-top: 0;
  }

  :deep(.data-card__title) {
    white-space: nowrap;
  }
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 0 28px 24px;
}

.station-search {
  .search-icon {
    cursor: pointer;
  }
}

.station-power {
  min-width: 80px;
}

.simple-chart {
  width: 60px;
  height: 30px;
}

.station-name {
  color: var(--color-primary);
  transition: text-decoration 0.2s ease;
  cursor: pointer;
}

.station-name:hover {
  text-decoration: underline;
}

.station-capacity {
  color: #6e7185;
}

.comm-status.online {
  background: #E8FFF3;
}

.comm-status.offline {
  background: #F4F9FF;
}

.alarm-status.normal {
  color: #52c41a;
}

.alarm-status.alarm {
  color: #ff4d4f;
}


.run-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid #fff;

  &.charge {
    background: var(--color-charging);
    box-shadow: 0 2px 4px color-mix(in srgb, var(--color-charging) 60%, transparent);
  }

  &.discharge {
    background: var(--color-discharge);
    box-shadow: 0 2px 4px color-mix(in srgb, var(--color-discharge) 60%, transparent);
  }

  &.stop {
    background: var(--color-stopped);
    box-shadow: 0 2px 4px color-mix(in srgb, var(--color-stopped) 60%, transparent);
  }

  &.standby {
    background: var(--color-standby);
    box-shadow: 0 2px 4px color-mix(in srgb, var(--color-standby) 60%, transparent);
  }
}

// 电站总览表格表头浅蓝底
.station-overview-card {
  :deep(.gm-table thead tr th) {
    background: #F2F5FE !important;
  }
}
</style>
